import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import RequireAuth from "@/components/RequireAuth";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import Home from "@/pages/Home";
import Discover from "@/pages/Discover";
import StartupDetail from "@/pages/StartupDetail";
import Drops from "@/pages/Drops";
import MapPage from "@/pages/MapPage";
import Following from "@/pages/Following";
import Profile from "@/pages/Profile";
import PublicProfile from "@/pages/PublicProfile";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import StartupDashboard from "@/pages/StartupDashboard";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import Footer from "@/components/Footer";
import { Toaster } from "sonner";

const gated = (el) => <RequireAuth>{el}</RequireAuth>;

function App() {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <AuthProvider>
                <BrowserRouter>
                    <AnalyticsTracker />
                    <Navbar />
                    <Routes>
                        {/* Public */}
                        <Route path="/" element={<Home />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/terms" element={<Terms />} />

                        {/* Auth-gated (browse) */}
                        <Route path="/discover" element={gated(<Discover />)} />
                        <Route path="/startup/:id" element={gated(<StartupDetail />)} />
                        <Route path="/drops" element={gated(<Drops />)} />
                        <Route path="/map" element={gated(<MapPage />)} />
                        <Route path="/following" element={gated(<Following />)} />
                        <Route path="/profile" element={gated(<Profile />)} />
                        <Route path="/u/:userId" element={gated(<PublicProfile />)} />
                        <Route path="/dashboard" element={gated(<StartupDashboard />)} />
                        <Route path="/admin" element={gated(<Admin />)} />

                        <Route path="*" element={<NotFound />} />
                    </Routes>
                    <Footer />
                </BrowserRouter>
                <Toaster theme="dark" position="top-right" richColors />
            </AuthProvider>
        </div>
    );
}

export default App;
